import React, { useEffect, useState } from "react";
import styles from "./admin-charts-page.module.css";
import DateRangeControls, { ChartsDateRange } from "./components/DateRangeControls/DataRangeControls";
import { getAdminBatches, getAdminUsers } from "@/api/admin";
import { useErrorModalContext } from "@/contexts/ErrorModalContext";
import { AdminPartialBatch, AdminPartialUser } from "@boxem/core-api-schema";
import NumShipmentsCreatedAndFinished from "./charts/NumShipmentsCreatedAndFinished/NumShipmentsCreatedAndFinished";
import TimeInEachShipmentStep from "./charts/TimeInEachShipmentStep/TimeInEachShipmentStep";
import TimeInShimentFlow from "./charts/TimeInShipmentFlow/TimeInShipmentFlow";
import Flex from "@/components/Flex/Flex";
import AvgSyncTime from "./stats/AvgSyncTime/AvgSyncTime";
import NumOfSyncStarted from "./stats/NumOfSyncStarted/NumOfSyncStarted";
import ActiveSessions from "./stats/ActiveSessions/ActiveSessions";
import AvgSessionTime from "./stats/AvgSessionTime/AvgSessionTime";
import TotalSessions from "./stats/TotalSessions/TotalSessions";
import ActiveUsers from "./stats/ActiveUsers/ActiveUsers";

type AdminChartsPageProps = {};

const AdminChartsPage = ({}: AdminChartsPageProps) => {
  const [range, setRange] = useState<ChartsDateRange>(ChartsDateRange.AllTime);
  const [batches, setBatches] = useState<AdminPartialBatch[]>([]);
  const [batchesLoading, setBatchesLoading] = useState<boolean>(false);
  const [users, setUsers] = useState<AdminPartialUser[]>([]);
  const [usersLoading, setUsersLoading] = useState<boolean>(false);
  const { handleErrorResponseGenerically } = useErrorModalContext();

  useEffect(() => {
    setBatchesLoading(true);

    //Fetch shipments for the given range
    getAdminBatches(range)
      .then(data => setBatches(data.batches))
      .finally(() => setBatchesLoading(false))
      .catch(err => handleErrorResponseGenerically(err));
  }, [range]);

  useEffect(() => {
    setUsersLoading(true);

    getAdminUsers(range)
      .then(data => setUsers(data.users))
      .finally(() => setUsersLoading(false))
      .catch(err => handleErrorResponseGenerically(err))
  }, [range]);

  return (
    <Flex
      justify="start"
      align="start"
      direction="column"
      className={styles.chartsPageContainer}
    >
      <DateRangeControls
        range={range}
        setRange={(range: ChartsDateRange) => setRange(range)}
      />

      <Flex
        justify="space-between"
        align="center"
        wrap="wrap"
        className={styles.chartsContainer}
      >
        <ActiveUsers
          users={users ?? []}
          loading={usersLoading}
        />

        <ActiveSessions
          users={users ?? []}
          loading={usersLoading}
        />

        <AvgSessionTime
          users={users ?? []}
          loading={usersLoading}
        />

        <TotalSessions
          users={users ?? []}
          loading={usersLoading}
        />
        
        <NumOfSyncStarted
          users={users ?? []}
          loading={usersLoading}
        />
        
        <AvgSyncTime
          users={users ?? []}
          loading={usersLoading}
        />
      </Flex>

      <Flex
        justify="space-between"
        align="center"
        wrap="wrap"
        className={styles.chartsContainer}
      >
        <NumShipmentsCreatedAndFinished
          batches={batches ?? []}
          loading={batchesLoading}
        />

        <TimeInEachShipmentStep
          batches={batches ?? []}
          loading={batchesLoading}
        />

        <TimeInShimentFlow
          batches={batches ?? []}
          loading={batchesLoading}
        />
      </Flex>
    </Flex>
  );
};

export default AdminChartsPage;